import { render, staticRenderFns } from "./ForStudents.vue?vue&type=template&id=5c6158cd&scoped=true&"
import script from "./ForStudents.vue?vue&type=script&lang=js&"
export * from "./ForStudents.vue?vue&type=script&lang=js&"
import style0 from "./ForStudents.vue?vue&type=style&index=0&id=5c6158cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6158cd",
  null
  
)

export default component.exports